import type { ReportSeriesPoint } from '@/app/reports/components/report-chart-utils';
import type { ReportLookupMaps } from '@/app/reports/hooks/useReportLookupMaps';
import { enrichSeriesLabel, resolveLookupLabel } from '@/app/reports/hooks/useReportLookupMaps';

export const enrichSeriesPoints = (
  series: ReportSeriesPoint[],
  maps: ReportLookupMaps,
): ReportSeriesPoint[] =>
  series.map((point) => ({
    ...point,
    label: point.label ? enrichSeriesLabel(point.label, maps) : point.label,
    series: point.series ? enrichSeriesLabel(point.series, maps) : point.series,
    date: enrichSeriesLabel(point.date, maps),
  }));

export const enrichTableRows = (
  rows: Record<string, string | number | null>[],
  maps: ReportLookupMaps,
): Record<string, string | number | null>[] =>
  rows.map((row) =>
    Object.fromEntries(
      Object.entries(row).map(([key, value]) => [
        key,
        typeof value === 'string' || typeof value === 'number' || value === null
          ? resolveLookupLabel(key, value, maps)
          : value,
      ]),
    ),
  );
